const REQUEST_CLIENTS_REQUIRING_ATTENTION =
  'platfi-ui-app/MONITOR/REQUEST_CLIENTS_REQUIRING_ATTENTION';
const REQUEST_CLIENTS_REQUIRING_ATTENTION_SUCCESS =
  'platfi-ui-app/MONITOR/REQUEST_CLIENTS_REQUIRING_ATTENTION_SUCCESS';
const REQUEST_CLIENTS_REQUIRING_ATTENTION_FAILURE =
  'platfi-ui-app/MONITOR/REQUEST_CLIENTS_REQUIRING_ATTENTION_FAILURE';

export {
  REQUEST_CLIENTS_REQUIRING_ATTENTION,
  REQUEST_CLIENTS_REQUIRING_ATTENTION_SUCCESS,
  REQUEST_CLIENTS_REQUIRING_ATTENTION_FAILURE,
};
